<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import SimulationMenu from './SimulationMenu.vue'
import AlertList from '../Alert/AlertList.vue'
import SimulationDevis from './SimulationDevis.vue'
import Comments from '../Comment/Comments.vue'
import Actors from '../Actor/Actors.vue'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import ModalSuccess from '../UI/Modal/ModalSuccess.vue'
import Profitabilities from '../Finance/Profitabilities.vue'
import RefinancerMismatchNotification from './RefinancerMismatchNotification.vue'
import SimulationDecision from './SimulationDecision.vue'
import SimulationDemand from './SimulationDemand.vue'
import SimulationService from './SimulationService.vue'
import ContractRestructuringView from '../ContractRestructuring/ContractRestructuringView.vue'

export default {
  components: {
    Actors,
    AlertList,
    Comments,
    ContractRestructuringView,
    ModalConfirmation,
    ModalSuccess,
    Profitabilities,
    RefinancerMismatchNotification,
    SimulationDecision,
    SimulationDemand,
    SimulationDevis,
    SimulationMenu,
    SimulationService,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      simulationId: parseInt(urlParams.get('i')),
      simulation: {
        id: parseInt(urlParams.get('i')),
        decisions: [],
        finance: {
          tender: false,
        },
        decisionAmount: 0,
        decision: null,
        status: 'CREATED',
        refinancerStatus: 'CREATED',
      },
      decisions: [],
      def: {},
      page: urlParams.get('p'),
      alertInformation: {
        status: '',
        number: 0,
        blocking: false,
      },
      showAlert: false,
      loading: true,
      isUpdatingContractRefinancer: false,
    }
  },
  computed: {
    canSendDemandToRefinancer() {
      const clientInFormation = this.simulation?.client?.inFormation ?? true

      return clientInFormation === false
    },
    hasRefinancerMismatchNotification() {
      const acceptedStatuses = this.conf.simulationStatusesDecision
        ? this.conf.simulationStatusesDecision.split('-')
        : ['ACCEPTED']
      return (
        this.simulation?.contractRefinancerId &&
        this.simulation?.decision.refinancer.id &&
        this.simulation?.contractRefinancerId !== this.simulation?.decision?.refinancer.id &&
        acceptedStatuses.includes(this.simulation?.decision?.status)
      )
    },
  },
  methods: {
    changeLink(page) {
      this.page = page
    },
    changeIndex(index) {
      this.$emit('change-index', index)
    },
    async getRefinancers() {
      const decisions = await this.getJSON('quotations/' + this.simulationId + '/refinancer')
      this.setValue(this.simulation, 'decisions', decisions)

      this.simulation.decisions.forEach((decision) => {
        if (decision.id === this.simulation.decision?.id) {
          this.setValue(this.simulation, 'decision', decision)
        }
      })

      if (this.$refs['devis']) {
        this.$refs['devis'].getProfitability()
      }
    },
    async getSimulation() {
      this.loading = true
      const json = await this.getJSON(`quotations/def?simulationId=${this.simulationId}&computeRefinancersRents=false`)
      this.$root.addValue(this.simulation, json.simulation)
      this.$root.addValue(this.def, json.config)
      this.loading = false
      this.getAlert()
    },
    serviceUpdate(services) {
      this.setValue(this.simulation.finance, 'services', services)
    },
    alertInfo(json) {
      if (json.length > 0) {
        const alertStatus = json.map((alert) => alert.status)
        const alertBlocking = json.some((alert) => alert.type?.blocking)

        const createdAlerts = alertStatus.filter((status) => ['CREATED', 'SENT'].includes(status))

        this.alertInformation = {
          number: createdAlerts.length,
          status: alertStatus.every((status) => status === 'ARCHIVED') ? 'ARCHIVED' : 'CREATED',
          blocking: alertBlocking,
        }
      } else {
        this.alertInformation.number = 0
      }

      if (!this.alertInformation.blocking) {
        this.setValue(this.simulation, 'blockedAt', false)
      }
    },
    showAlertList() {
      this.showAlert = !this.showAlert
    },
    getAlert() {
      if (this.$refs.alertlist) {
        this.$refs.alertlist.loadAlert()
      }
    },
    refreshSimulation() {
      this.getSimulation()
    },
    setSimulation(simulation) {
      this.simulation = simulation
    },
    async confirmUpdateContractRefinancer() {
      this.$refs.modalConfirmationUpdateContractRefinancer.closeModal()
      const contractId = this.simulation?.contractId
      const decisionId = this.simulation?.decision?.id
      try {
        this.isUpdatingContractRefinancer = true
        const contract = await this.patchJSON(`contracts/${contractId}/decision`, { decisionId })
        this.simulation.contractRefinancerId = contract.refinancer.id
        this.$refs.modalSuccessUpdateContractRefinancer.open()
      } finally {
        this.isUpdatingContractRefinancer = false
      }
    },
    updateContractRefinancer() {
      this.$refs.modalConfirmationUpdateContractRefinancer.showModal()
    },
  },

  mounted() {
    window.addEventListener('popstate', (event) => {
      let urlParams = new URLSearchParams(window.location.search)
      this.page = urlParams.get('p')
    })
  },

  async beforeMount() {
    await this.getSimulation()
    await this.getRefinancers()
  },
}
</script>
<template>
  <div>
    <SimulationMenu
      :simulation="simulation"
      :alert-information="alertInformation"
      :active="page"
      @link="changeLink"
      @show-alert="showAlertList"
    />
    <RefinancerMismatchNotification
      v-if="hasRefinancerMismatchNotification"
      :is-updating="isUpdatingContractRefinancer"
      @update="updateContractRefinancer"
    />
    <AlertList
      ref="alertlist"
      v-if="hasRole('ROLE_ALERT_SHOW')"
      context="AppBundle\Entity\Simulation"
      :context-id="simulationId"
      :show="showAlert"
      @alert-info="alertInfo"
    />
    <SimulationDevis
      v-if="page === 'devis'"
      ref="devis"
      :simulation-id="simulationId"
      :simulation="simulation"
      :def="def"
      :decisions="decisions"
      @service-updated="serviceUpdate"
      @update-simulation="getSimulation"
      @change-index="changeIndex"
    />
    <SimulationService
      v-if="page === 'service'"
      :simulation-id="simulationId"
      :simulation="simulation"
      :def="def"
      @set-simulation="setSimulation"
      @simulation-changed="refreshSimulation"
    />
    <SimulationDemand
      v-if="page === 'demand'"
      :simulation-id="simulationId"
      :simulation="simulation"
      :def="def"
      @update-simulation="getSimulation"
    />
    <SimulationDecision
      v-if="page === 'decision' && canSendDemandToRefinancer"
      :simulation-id="simulationId"
      :simulation="simulation"
      :def="def"
      @update-simulation="getSimulation"
      @call:alert="getAlert"
    />
    <Profitabilities
      v-if="page === 'profitability' && hasRole('ROLE_PROFITABILITY_SHOW')"
      :id="Number(simulationId)"
      context="quotations"
    />
    <Actors
      v-if="page === 'actors'"
      :id="simulationId"
      endpoint="quotations"
      :context="simulation"
      :disabled="simulation.hasContract"
      @reload-data="getAlert"
    />
    <Comments v-if="page === 'comments'" :simulation-id="simulationId" :contract-id="simulation.contractId" />
    <ContractRestructuringView
      v-if="page === 'restructuring' && hasRole('ROLE_RESTRUCTURING')"
      :restructuring="simulation.finance.restructuring"
    />
    <ModalConfirmation
      ref="modalConfirmationUpdateContractRefinancer"
      id="modalConfirmationUpdateContractRefinancer"
      title="simulation.contractRefinancerNotification.confirmation"
      button-cancel-title="main.close"
      @confirm="confirmUpdateContractRefinancer"
    />
    <ModalSuccess
      ref="modalSuccessUpdateContractRefinancer"
      id="modalSuccessUpdateContractRefinancer"
      :success="$t('simulation.contractRefinancerNotification.success')"
    />
  </div>
</template>
